// @flow

import Config from "@Config";
import PubSub from "../modules/util/pubsub";
export const initYoutubeApi = (): any => {
    return new Promise((resolve: any, reject: any) => {
        // timeout reject
        let requestTimeout = setTimeout(() => {
            reject("Youtube API timed out.");
        }, Config.fetchTimeout);

        // loaded resolve
        window.onYouTubeIframeAPIReady = () => {
            clearTimeout(requestTimeout);
            PubSub.publish("youtube-api-loaded");
            resolve();
        };

        // async script include
        let youtubeJS = document.createElement("script");
        youtubeJS.type = "text/javascript";
        youtubeJS.async = true;
        youtubeJS.src = `https://www.youtube.com/iframe_api`;
        if (document && document.body) document.body.appendChild(youtubeJS);
    });
};
initYoutubeApi();
